import React, { useEffect } from 'react'
import { useSelector } from 'react-redux'
import { Card, Container } from 'reactstrap'
import { useDispatch } from 'react-redux'

import { fetchSelfAssignableCourses } from 'store/AllCourses/actions'
import { fetchSelfAssignedCourses } from 'store/AllCourses/actions'
import Course from './CourseDetails'
import Loader from '../Loader'
import './styles/styles.css'
import 'views/pages/LearningPlan/style.css'

// Custom Css Leon
import '../../../assets/css/Global/style.css'

const AllCourses = (props) => {
  const language = useSelector((state) => state.language?.language?.data)
  const allCourses = useSelector((state) => state.allCourses)
  const dispatch = useDispatch()
  useEffect(() => {
    dispatch(fetchSelfAssignableCourses())
    dispatch(fetchSelfAssignedCourses())
  }, [])

  return (
    <Container className='mt--6' fluid>
      <Card className='py-4 px-3' style={{ minHeight: '85vh' }}>
        {allCourses.coursesLoading ? (
          <div
            className='dFlex justifyCenter itemsCenter textCenter'
            style={{ minHeight: '80vh' }}
          >
            <Loader />
          </div>
        ) : (
          <div className=' '>
            {allCourses && allCourses.courses.length ? (
              <div className='dFlex flex-wrap'>
                {allCourses.courses.map((courseItem, index) => {
                  return (
                    <Course
                      {...props}
                      courseItem={courseItem}
                      key={index}
                      language={language}
                    />
                  )
                })}
              </div>
            ) : (
              <div
                className='dFlex justifyCenter itemsCenter textCenter'
                style={{ minHeight: '80vh' }}
              >
                <p className='text-primary blockquote font-weight-normal'>
                  {language?.my_library?.no_items}
                </p>
              </div>
            )}
          </div>
        )}
      </Card>
    </Container>
  )
}

export default AllCourses
